(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7846],{

/***/ 30553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var _FormControl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22601);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1591);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93871);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function FormControlLabel(props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = (0,_FormControl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(control, controlProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    component: "span",
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(classes.label, disabled && classes.disabled)
  }, label));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel));

/***/ }),

/***/ 56608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97685);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45987);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86010);
/* harmony import */ var _utils_useControlled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22775);
/* harmony import */ var _FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22601);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1591);
/* harmony import */ var _IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17812);











var styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _useControlled = (0,_utils_useControlled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  }),
      _useControlled2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useControlled, 2),
      checked = _useControlled2[0],
      setCheckedState = _useControlled2[1];

  var muiFormControl = (0,_FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v5: remove the second argument.
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    component: "span",
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("input", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase));

/***/ }),

/***/ 71843:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');

exports.Z = _default;

/***/ }),

/***/ 1197:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}), 'ArrowForwardIos');

exports.Z = _default;

/***/ }),

/***/ 83792:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z"
}), 'Facebook');

exports.Z = _default;

/***/ }),

/***/ 20551:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"
}), 'LinkedIn');

exports.Z = _default;

/***/ }),

/***/ 69193:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
}), 'Phone');

exports.Z = _default;

/***/ }),

/***/ 67123:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

exports.Z = _default;

/***/ }),

/***/ 85984:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

exports.Z = _default;

/***/ }),

/***/ 83817:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarBorder');

exports.Z = _default;

/***/ }),

/***/ 74419:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
}), 'StarHalf');

exports.Z = _default;

/***/ }),

/***/ 44704:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

var _interopRequireWildcard = __webpack_require__(75263);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var React = _interopRequireWildcard(__webpack_require__(67294));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(2108));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"
}), 'Twitter');

exports.Z = _default;

/***/ }),

/***/ 69832:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/start/[stepId]",
      function () {
        return __webpack_require__(80155);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 80155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _stepId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./src/lib/ablyft/index.ts
var ablyft = __webpack_require__(49423);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var es_useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./public/artifacts/icons/checked.svg
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgChecked(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.73 11.245L3.776 8.29 2.77 9.29l3.96 3.96 8.5-8.5-1-1-7.5 7.495z",
    fill: "#007F33"
  })));
}
/* harmony default export */ var checked = (SvgChecked);
;// CONCATENATED MODULE: ./public/artifacts/icons/clock.svg
var clock_path, _path2;
function clock_extends() { clock_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return clock_extends.apply(this, arguments); }

function SvgClock(props) {
  return /*#__PURE__*/react.createElement("svg", clock_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), clock_path || (clock_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.125a6.375 6.375 0 100 12.75 6.375 6.375 0 000-12.75zM.208 8.5a7.792 7.792 0 1115.584 0 7.792 7.792 0 01-15.584 0z",
    fill: "#007F33"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3.542c.391 0 .709.317.709.708v3.812l2.441 1.221a.708.708 0 11-.633 1.267L7.683 9.134a.708.708 0 01-.391-.634V4.25c0-.391.317-.708.708-.708z",
    fill: "#007F33"
  })));
}
/* harmony default export */ var clock = (SvgClock);
;// CONCATENATED MODULE: ./public/artifacts/icons/delivery.svg
var delivery_path, delivery_path2, _path3;
function delivery_extends() { delivery_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return delivery_extends.apply(this, arguments); }

function SvgDelivery(props) {
  return /*#__PURE__*/react.createElement("svg", delivery_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    fill: "none"
  }, props), delivery_path || (delivery_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 1.125c0-.391.317-.708.708-.708h10.625c.392 0 .709.317.709.708v9.208a.708.708 0 01-.709.709H1.208a.708.708 0 01-.708-.709V1.125zm1.417.708v7.792h9.208V1.833H1.917z",
    fill: "#007F33"
  })), delivery_path2 || (delivery_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.125 4.667c0-.392.317-.709.708-.709h2.834c.188 0 .368.075.5.208l2.126 2.125a.708.708 0 01.207.5v3.542a.708.708 0 01-.708.709h-4.959a.708.708 0 01-.708-.709V4.667zm1.417.708v4.25h3.541v-2.54l-1.71-1.71h-1.831zM4.396 11.042a1.063 1.063 0 100 2.125 1.063 1.063 0 000-2.125zm-2.48 1.062a2.48 2.48 0 114.959 0 2.48 2.48 0 01-4.958 0z",
    fill: "#007F33"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.604 11.042a1.063 1.063 0 100 2.125 1.063 1.063 0 000-2.125zm-2.479 1.062a2.48 2.48 0 114.958 0 2.48 2.48 0 01-4.958 0z",
    fill: "#007F33"
  })));
}
/* harmony default export */ var delivery = (SvgDelivery);
;// CONCATENATED MODULE: ./public/artifacts/icons/shopping-cart.svg
var _g, _defs;
function shopping_cart_extends() { shopping_cart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return shopping_cart_extends.apply(this, arguments); }

function SvgShoppingCart(props) {
  return /*#__PURE__*/react.createElement("svg", shopping_cart_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#shopping-cart_svg__clip0_27100_239364)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#007F33"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M5.458 14.875a1.417 1.417 0 112.834 0 1.417 1.417 0 01-2.833 0zM13.25 14.875a1.417 1.417 0 112.833 0 1.417 1.417 0 01-2.833 0zM.5.708C.5.318.817 0 1.208 0h2.834c.337 0 .628.238.694.57l.595 2.972h11.46a.708.708 0 01.697.84l-1.135 5.949a2.124 2.124 0 01-2.118 1.71H7.364a2.125 2.125 0 01-2.118-1.71L4.062 4.42a.706.706 0 01-.012-.06l-.589-2.942H1.208A.708.708 0 01.5.708zm5.115 4.25l1.02 5.097a.708.708 0 00.708.57h6.912a.708.708 0 00.708-.568l.973-5.099H5.614z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "shopping-cart_svg__clip0_27100_239364"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h17v17H0z"
  })))));
}
/* harmony default export */ var shopping_cart = (SvgShoppingCart);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Star.js
var Star = __webpack_require__(85984);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/StarBorder.js
var StarBorder = __webpack_require__(83817);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/StarHalf.js
var StarHalf = __webpack_require__(74419);
;// CONCATENATED MODULE: ./src/qualification/components/CatererCard/Ratings.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: underline;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var HIGHEST_SCORE = 5;
function Rating(param) {
    var score = param.score, ratingCount = param.ratingCount;
    var i18n = (0,es_useTranslation/* useTranslation */.$)().i18n;
    var t = (0,es_useTranslation/* useTranslation */.$)("static_pages").t;
    var formatNumberForLocale = function(number) {
        return number.toLocaleString(i18n.languages[0], {
            minimumFractionDigits: 1
        });
    };
    var normalizedScore = react.useMemo(function() {
        return score / 10;
    }, [
        score
    ]);
    var filledStarsArray = react.useMemo(function() {
        return Array.from({
            length: Math.floor(normalizedScore)
        });
    }, [
        normalizedScore
    ]);
    var emptyStarsArray = react.useMemo(function() {
        return Array.from({
            length: Math.floor(HIGHEST_SCORE - normalizedScore)
        });
    }, [
        normalizedScore
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
        display: "flex",
        flexWrap: "wrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                mr: 0.5,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        color: "#007F33",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            mr: 1,
                            variant: "body1",
                            color: "inherit",
                            lineHeight: "26.88px",
                            fontSize: 16,
                            children: formatNumberForLocale(normalizedScore)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        lineHeight: "normal",
                        children: [
                            filledStarsArray.map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {
                                    color: "secondary",
                                    fontSize: "small"
                                }, index);
                            }),
                            normalizedScore % 1 !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(StarHalf/* default */.Z, {
                                color: "secondary",
                                fontSize: "small"
                            }),
                            emptyStarsArray.map(function(_, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StarBorder/* default */.Z, {
                                    color: "secondary",
                                    fontSize: "small"
                                }, index);
                            })
                        ]
                    })
                ]
            }),
            ratingCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                color: "#686D6B",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Typography */.ZT, {
                    color: "inherit",
                    fontSize: {
                        xs: 12,
                        md: 16
                    },
                    children: [
                        "(",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Underline, {
                            children: t("catererCards.ratingCount", {
                                count: ratingCount
                            })
                        }),
                        ")"
                    ]
                })
            })
        ]
    });
}
var Underline = styled_components_browser_esm/* default.span */.ZP.span(_templateObject());
/* harmony default export */ var Ratings = (Rating);

// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./src/shared/hooks/useLocalizedFieldName.js
var hooks_useLocalizedFieldName = __webpack_require__(25734);
// EXTERNAL MODULE: ./src/shared/svg/QualityAndSafetyIcon.tsx
var QualityAndSafetyIcon = __webpack_require__(66442);
;// CONCATENATED MODULE: ./src/qualification/components/CatererCard/index.tsx



function CatererCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 14px;\n\n  ",
        " {\n    font-size: 16px;\n  }\n"
    ]);
    CatererCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  color: #3c4340;\n  grid-template-columns: 17px 1fr;\n  align-items: center;\n  row-gap: ",
        "px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #007f33;\n  background-color: #f7fcfa;\n\n  border-radius: ",
        "px;\n\n  img {\n    width: 100%;\n    display: block;\n    position: relative;\n    transition: transform 0.5s ease, filter 0.5s ease;\n  }\n  overflow: hidden;\n\n  ",
        " {\n    width: ",
        "px;\n  }\n\n  ",
        " {\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-grow: 1;\n  padding: ",
        ";\n  min-height: 145px;\n  ",
        " {\n    min-height: 160px;\n  }\n  ",
        " {\n    min-height: fit-content;\n    #details {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: nowrap;\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    width: 40px;\n    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fff);\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #3c4340;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 172.5%;\n\n  ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n\n  line-height: 26.88px;\n  color: rgba(0, 0, 0, 0.6);\n  min-height: ",
        "px;\n  margin-top: ",
        "px;\n\n  ",
        " {\n    font-size: 16px;\n    font-weight: 500;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: ",
        "px;\n  left: ",
        "px;\n  padding: ",
        ";\n  height: 28px;\n  display: flex;\n\n  color: #007f33;\n  font-weight: 600;\n  justify-content: center;\n  align-items: center;\n  background: #f5f5f5;\n  border-radius: ",
        "px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  height: 0px;\n  margin: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-self: end;\n  display: flex;\n  align-items: center;\n  height: auto;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}














var CARD_WIDTH = 335;
var CARD_WIDTH_MD = 260;
function CatererCard(param) {
    var caterer = param.caterer;
    var t = (0,es_useTranslation/* useTranslation */.$)("static_pages").t;
    var localizedFieldAlgolia = (0,hooks_useLocalizedFieldName/* default */.Z)().localizedFieldAlgolia;
    var isCertified = caterer.quality_safety_rating === "Quality Proven Partner";
    var isSmUp = (0,useBreakpoints/* useBreakpointUp */._)("sm");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCatererCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                        children: caterer.profile_image && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            alt: "",
                            height: isSmUp ? "126px" : "65px",
                            width: CARD_WIDTH,
                            layout: "responsive",
                            src: caterer.profile_image,
                            objectFit: "cover"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPill, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                            lineHeight: 1,
                            color: "rgba(0,0,0, 0.6)",
                            fontWeight: 600,
                            variant: "caption",
                            children: t("catererCards.yourSelectedCaterer")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CatererInformationWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CatererInformation, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardTitleTypography, {
                            children: [
                                caterer.company_name,
                                " ",
                                isCertified ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QualityAndSafetyIcon/* default */.Z, {
                                    fontSize: "small"
                                }) : null
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SloganTypography, {
                        variant: "body2",
                        children: caterer[localizedFieldAlgolia("slogan")]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "details",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {}),
                            caterer.rating_score && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                display: "flex",
                                alignItems: "center",
                                my: 1.5,
                                mb: 2,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ratings, {
                                    score: caterer.rating_score,
                                    ratingCount: caterer.number_of_ratings
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoGrid, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(checked, {
                                            height: "17",
                                            width: "17",
                                            fontSize: "inherit"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfoTypography, {
                                        variant: "caption",
                                        ml: 1,
                                        children: [
                                            caterer.number_of_orders,
                                            " Caterings"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(delivery, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                        variant: "caption",
                                        fontSize: 12,
                                        ml: 1,
                                        mr: 1.5,
                                        children: caterer.minimum_delivery_fee === 0 ? t("catererCards.freeDelivery", {
                                            amount: wholeNumberWithCurrencySymbol(caterer.minimum_delivery_fee)
                                        }) : t("catererCards.delivery", {
                                            amount: wholeNumberWithCurrencySymbol(caterer.minimum_delivery_fee)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(shopping_cart, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                        variant: "caption",
                                        ml: 1,
                                        children: t("catererCards.orderFrom", {
                                            amount: caterer.minimum_order_value / 100
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoIcon, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(clock, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTypography, {
                                        variant: "caption",
                                        ml: 1,
                                        children: t("catererCards.leadTime", {
                                            days: caterer.numeric_lead_time,
                                            count: caterer.numeric_lead_time
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function wholeNumberWithCurrencySymbol(number) {
    return "".concat(Math.floor(number / 100), "€");
}
var InfoTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(CatererCard_templateObject(), function(param) {
    var theme = param.theme;
    return theme.palette.grey.secondary;
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var InfoGrid = styled_components_browser_esm/* default.div */.ZP.div(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.spacing(1.5);
});
var StyledCatererCard = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), function(props) {
    return props.theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, CARD_WIDTH_MD, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, CARD_WIDTH);
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var CatererInformation = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4());
var CatererInformationWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject5(), function(props) {
    return props.theme.spacing(2, 2);
}, function(props) {
    return props.theme.breakpoints.down("sm");
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var TruncatedTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject6());
var CardTitleTypography = (0,styled_components_browser_esm/* default */.ZP)(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TruncatedTypography, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        variant: "h4",
        fontSize: "18px",
        component: "h4"
    }));
})(_templateObject7(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var SloganTypography = (0,styled_components_browser_esm/* default */.ZP)(TruncatedTypography)(_templateObject8(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.spacing(0.5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
});
var StyledPill = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(_templateObject9(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(0.5, 1);
}, function(props) {
    return props.theme.spacing(0.5);
});
var Divider = styled_components_browser_esm/* default.div */.ZP.div(_templateObject10(), function(props) {
    return props.theme.palette.grey[200];
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1, 0);
});
var InfoIcon = styled_components_browser_esm/* default.div */.ZP.div(_templateObject11());

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ReportProblemOutlined.js
var ReportProblemOutlined = __webpack_require__(67123);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/helpers.ts
var helpers = __webpack_require__(10904);
;// CONCATENATED MODULE: ./src/qualification/components/QuestionErrors.tsx

function QuestionErrors_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  list-style: none;\n  padding-left: 0;\n  margin: 0;\n"
    ]);
    QuestionErrors_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







function QuestionErrors_QuestionErrors(param) {
    var errors = param.errors;
    var t = (0,es_useTranslation/* useTranslation */.$)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
        color: "red",
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        children: errors !== undefined && /*#__PURE__*/ (0,jsx_runtime.jsx)(UnorderedList, {
            children: errors.map(function(error) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        display: "flex",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                as: "span",
                                mr: 1,
                                lineHeight: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReportProblemOutlined/* default */.Z, {
                                    fontSize: "small"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body1",
                                fontSize: 14,
                                children: (0,helpers/* capitalizeFirstLetter */.fm)(t(error))
                            })
                        ]
                    })
                }, error);
            })
        })
    });
}
var UnorderedList = styled_components_browser_esm/* default.ul */.ZP.ul(QuestionErrors_templateObject());
/* harmony default export */ var components_QuestionErrors = (QuestionErrors_QuestionErrors);

// EXTERNAL MODULE: ./src/qualification/context/index.tsx + 11 modules
var context = __webpack_require__(85643);
// EXTERNAL MODULE: ./src/qualification/schema/questions/index.ts
var schema_questions = __webpack_require__(89121);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/PriceField.tsx



function PriceField_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  column-gap: ",
        "px;\n  row-gap: ",
        "px;\n"
    ]);
    PriceField_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PriceField_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 10px;\n  text-align: right;\n  color: ",
        ";\n"
    ]);
    PriceField_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PriceField_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 243px;\n"
    ]);
    PriceField_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PriceField_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    PriceField_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function PriceField_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: ",
        "px;\n  top: 50%;\n  transform: translateY(-50%);\n"
    ]);
    PriceField_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}









var totalBudgetQuestion = schema_questions/* questions.totalBudget */.X.totalBudget;
function PriceField_PriceField() {
    var ref = useQualification(), state = ref.state, actions = ref.actions, answerOf = ref.answerOf, errorsOf = ref.errorsOf;
    var t = useTranslation("qualification").t;
    var localizedAttributeName = useLocalizedFieldName().localizedAttributeName;
    if (!("qualification" in state)) {
        return null;
    }
    var totalBudget = state.qualification.answers.min_order_number;
    var _content;
    var content = (_content = totalBudgetQuestion.content) !== null && _content !== void 0 ? _content : {};
    var localizedAssistiveText = // @ts-expect-error TODO: type this function
    content[localizedAttributeName("assistiveText")];
    var handleChange = function() {
        var _ref = _async_to_generator(function(event) {
            var price;
            return _ts_generator(this, function(_state) {
                if (!totalBudget) {
                    return [
                        2
                    ];
                }
                price = Number(event.target.value);
                if (isNaN(price)) {
                    return [
                        2
                    ];
                }
                if (price < 1) {
                    return [
                        2
                    ];
                }
                actions.answerQuestion(totalBudgetQuestion.id, price);
                return [
                    2
                ];
            });
        });
        return function handleChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var answer = answerOf(totalBudgetQuestion.id);
    var errors = errorsOf(totalBudgetQuestion.id);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        display: "flex",
        justifyContent: "center",
        alignItems: {
            xs: "center",
            sm: "top"
        },
        mt: [
            2,
            4
        ],
        mb: 2,
        flexWrap: "wrap",
        flexDirection: {
            xs: "column",
            sm: "row"
        },
        children: [
            /*#__PURE__*/ _jsx(Box, {
                alignSelf: {
                    sm: "start"
                },
                children: /*#__PURE__*/ _jsx(Typography, {
                    variant: "body2",
                    mt: 2,
                    fontWeight: 600,
                    children: t("total")
                })
            }),
            /*#__PURE__*/ _jsxs(StyledPriceField, {
                children: [
                    /*#__PURE__*/ _jsxs(FormControl, {
                        children: [
                            /*#__PURE__*/ _jsxs(InputWithAdornment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Input, {
                                        type: "number",
                                        name: totalBudgetQuestion.id,
                                        id: totalBudgetQuestion.id,
                                        // @ts-expect-error TODO: type this function
                                        placeholder: content[localizedAttributeName("placeholder")] || "",
                                        onChange: handleChange,
                                        value: answer || ""
                                    }),
                                    /*#__PURE__*/ _jsx(Adornment, {
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            children: "€"
                                        })
                                    })
                                ]
                            }),
                            localizedAssistiveText && /*#__PURE__*/ _jsx(StyledFormHelperText, {
                                children: localizedAssistiveText
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(QuestionErrors, {
                        errors: errors
                    })
                ]
            })
        ]
    });
}
var Wrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(PriceField_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(7);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
var StyledFormHelperText = (0,styled_components_browser_esm/* default */.ZP)(esm/* FormHelperText */.Q6)(PriceField_templateObject1(), function(props) {
    return props.theme.palette.text.secondary;
});
var StyledPriceField = styled_components_browser_esm/* default.div */.ZP.div(PriceField_templateObject2());
var InputWithAdornment = styled_components_browser_esm/* default.div */.ZP.div(PriceField_templateObject3());
var Adornment = styled_components_browser_esm/* default.div */.ZP.div(PriceField_templateObject4(), function(props) {
    return props.theme.spacing(2);
});
/* harmony default export */ var question_types_PriceField = ((/* unused pure expression or super */ null && (PriceField_PriceField)));

// EXTERNAL MODULE: ./src/qualification/context/model.ts
var model = __webpack_require__(91538);
// EXTERNAL MODULE: ./src/system/components/ButtonGroupSelect/PriceStepperField.tsx
var ButtonGroupSelect_PriceStepperField = __webpack_require__(87733);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/PriceStepper.tsx

function PriceStepper_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  column-gap: ",
        "px;\n  row-gap: ",
        "px;\n"
    ]);
    PriceStepper_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function PriceStepper_PriceStepper(param) {
    var question = param.question;
    var ref = useQualification(), state = ref.state, actions = ref.actions, answerOf = ref.answerOf;
    var handleChange = function(value) {
        if (Number(value) < 1) {
            return;
        }
        actions.answerQuestion(question.id, value);
    };
    var t = useTranslation("qualification").t;
    if (state.status !== QUALIFICATION_STATUS.answering) {
        return null;
    }
    var minOrderNumber = state.qualification.answers.min_order_number;
    var answer = answerOf(question.id);
    var errors = state.qualification.errors[question.id] || [];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(PriceStepper_Wrapper, {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: {
                    xs: "center",
                    sm: "baseline"
                },
                flexDirection: {
                    xs: "column",
                    sm: "row"
                },
                flexShrink: "0",
                mt: {
                    xs: 5,
                    sm: 5
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        fontWeight: 600,
                        pb: {
                            xs: 2,
                            sm: 0
                        },
                        children: t("budgetPerPerson")
                    }),
                    /*#__PURE__*/ _jsxs(Box, {
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(PriceStepperField, {
                                name: question.id,
                                id: question.id,
                                min: 0,
                                error: !!errors.length,
                                value: answer && Math.floor(answer) || 0,
                                onChange: handleChange
                            }),
                            /*#__PURE__*/ _jsx(Box, {
                                display: "flex",
                                alignItems: "center",
                                width: "fill-available",
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body2",
                                    fontWeight: 600,
                                    mt: 4,
                                    style: {
                                        width: "100%",
                                        textAlign: "end"
                                    },
                                    children: t("amountPeople", {
                                        amount: minOrderNumber
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                maxWidth: 400,
                mx: "auto"
            })
        ]
    });
}
var PriceStepper_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(PriceStepper_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(7);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(1);
});
/* harmony default export */ var question_types_PriceStepper = ((/* unused pure expression or super */ null && (PriceStepper_PriceStepper)));

// EXTERNAL MODULE: ./src/qualification/schema/questions/peopleCountQuestion.ts
var questions_peopleCountQuestion = __webpack_require__(65231);
;// CONCATENATED MODULE: ./src/system/components/PopularValues.js

function PopularValues_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        "rem;\n"
    ]);
    PopularValues_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PopularValues_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-bottom: 1px dotted #000;\n  cursor: pointer;\n"
    ]);
    PopularValues_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





function PopularValues_PopularValues(param) {
    var name = param.name, answerQuestion = param.answerQuestion, options = param.options;
    var t = useTranslation("qualification").t;
    return /*#__PURE__*/ _jsxs(FlexBox, {
        flexWrap: "wrap",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
        px: 2,
        id: name,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "caption",
                fontWeight: 500,
                children: t("popularValues")
            }),
            options.map(function(option, index) {
                return /*#__PURE__*/ _jsx(Box, {
                    onClick: function() {
                        return answerQuestion(option.value);
                    },
                    children: /*#__PURE__*/ _jsx(StyledTypography, {
                        variant: "caption",
                        children: option.label
                    })
                }, "".concat(option.value, "::").concat(index));
            })
        ]
    });
}
/* harmony default export */ var components_PopularValues = ((/* unused pure expression or super */ null && (PopularValues_PopularValues)));
var FlexBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(PopularValues_templateObject(), function(props) {
    return props.gap || 0;
});
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(PopularValues_templateObject1());

// EXTERNAL MODULE: ./src/system/components/QuantityStepperField.tsx
var components_QuantityStepperField = __webpack_require__(84561);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/QuantityStepper.tsx










function QuantityStepper_QuantityStepper() {
    var localizedAttributeName = useLocalizedFieldName().localizedAttributeName;
    var ref = useQualification(), actions = ref.actions, state = ref.state, answerOf = ref.answerOf;
    var localizedOptions = useMemo(function() {
        var ref;
        return (ref = questions.peopleCount.suggestions) === null || ref === void 0 ? void 0 : ref.map(function(option) {
            return {
                value: option.value,
                // @ts-expect-error TODO: type this function
                label: option[localizedAttributeName("label")]
            };
        });
    }, []);
    if (state.status !== QUALIFICATION_STATUS.answering) {
        return null;
    }
    var answer = answerOf(peopleCountQuestion.id);
    return /*#__PURE__*/ _jsxs(Box, {
        my: 5,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        children: [
            /*#__PURE__*/ _jsx(QuantityStepperField, {
                name: peopleCountQuestion.id,
                id: peopleCountQuestion.id,
                value: answer || 0,
                onChange: function(value) {
                    return actions.answerQuestion(peopleCountQuestion.id, value);
                }
            }),
            /*#__PURE__*/ _jsx(Box, {
                mt: 4,
                children: /*#__PURE__*/ _jsx(PopularValues, {
                    name: peopleCountQuestion.id,
                    answerQuestion: function(value) {
                        return actions.answerQuestion(peopleCountQuestion.id, value);
                    },
                    options: localizedOptions
                })
            })
        ]
    });
}
/* harmony default export */ var question_types_QuantityStepper = ((/* unused pure expression or super */ null && (QuantityStepper_QuantityStepper)));

// EXTERNAL MODULE: ./src/qualification/schema/questions/budgetQuestion.ts
var budgetQuestion = __webpack_require__(92789);
// EXTERNAL MODULE: ./src/qualification/schema/steps/index.ts
var schema_steps = __webpack_require__(82546);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/BudgetFields.tsx

function BudgetFields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #e86202;\n  font-weight: 500;\n  max-width: 500px;\n  margin: 0 auto;\n"
    ]);
    BudgetFields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}











function BudgetFields() {
    var errorsOf = useQualification().errorsOf;
    var pricePerPersonErrors = errorsOf(pricePerPersonQuestion.id);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                children: steps.budgetAndPeopleCount.questions.map(function(question) {
                    if (question.id === questions.peopleCount.id) {
                        return /*#__PURE__*/ _jsx(QuantityStepper, {}, "");
                    }
                    if (question.id === questions.pricePerPerson.id) {
                        return /*#__PURE__*/ _jsx(PriceStepper, {
                            question: question
                        }, question.id);
                    }
                    if (question.id === questions.totalBudget.id) {
                        return /*#__PURE__*/ _jsx(PriceField, {}, question.id);
                    }
                })
            }),
            /*#__PURE__*/ _jsx(ErrorWrapper, {
                children: pricePerPersonErrors[0]
            })
        ]
    });
}
var ErrorWrapper = styled_components_browser_esm/* default.div */.ZP.div(BudgetFields_templateObject());
/* harmony default export */ var question_types_BudgetFields = ((/* unused pure expression or super */ null && (BudgetFields)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var src_async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./src/shared/helpers/collections.js
function findIndexOnCollection(selectedOption, options) {
    if (!selectedOption) return null;
    if (Array.isArray(selectedOption)) {
        var findIndices = selectedOption.map(function(selectedOption) {
            return options.findIndex(function(option) {
                return option.value === selectedOption;
            });
        }).sort();
        return findIndices.pop();
    } else {
        return options.findIndex(function(option) {
            return option.value === selectedOption;
        });
    }
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/shared/svg/CheckmarkIcon.tsx





var CheckmarkIcon = function(_param) {
    var checked = _param.checked, svgProps = (0,_object_without_properties/* default */.Z)(_param, [
        "checked"
    ]);
    return checked ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedIcon, (0,_object_spread/* default */.Z)({}, svgProps)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UncheckedIcon, (0,_object_spread/* default */.Z)({}, svgProps));
};
var UncheckedIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            id: "ic-not_selected",
            "data-name": "ic-not selected",
            fill: "none",
            stroke: "#eee",
            strokeWidth: "2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12",
                    stroke: "none"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "11",
                    fill: "none"
                })
            ]
        })
    }));
};
var CheckedIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            id: "ic-selected",
            d: "M12,0A12,12,0,1,0,24,12,12,12,0,0,0,12,0ZM9.6,18l-6-6,1.692-1.692L9.6,14.6,18.708,5.5,20.4,7.2Z",
            fill: "#9cba6c"
        })
    }));
};
/* harmony default export */ var svg_CheckmarkIcon = (CheckmarkIcon);

;// CONCATENATED MODULE: ./src/system/components/CardSelect/CardSelectItem.tsx

function CardSelectItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &:hover {\n        box-shadow: 0 4px 40px 0 rgba(62, 41, 29, 0.08);\n      }\n    "
    ]);
    CardSelectItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardSelectItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: grid;\n  background-color: white;\n  justify-items: ",
        ";\n\n  grid-template-columns: ",
        ";\n\n  align-items: center;\n  white-space: nowrap;\n  border-width: 2px;\n  border-style: solid;\n  border-color: ",
        ";\n  border-radius: ",
        "px;\n  box-shadow: ",
        ";\n  overflow: hidden;\n  transition: ",
        ";\n\n  ",
        "\n\n  ",
        " {\n    flex-direction: row;\n  }\n"
    ]);
    CardSelectItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CardSelectItem_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      flex-basis: ",
        "px;\n      flex-grow: 0;\n      flex-shrink: 0;\n    "
    ]);
    CardSelectItem_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CardSelectItem_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  & > div {\n    display: block !important;\n  }\n  ",
        "\n  ",
        " {\n    flex-basis: ",
        "px;\n    flex-grow: 0;\n    flex-shrink: 0;\n  }\n"
    ]);
    CardSelectItem_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CardSelectItem_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-overflow: ellipsis;\n  overflow: hidden;\n  > * {\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  max-width: 100%;\n\n  padding-left: ",
        "px;\n  padding-top: ",
        "px;\n  padding-bottom: ",
        "px;\n\n  ",
        " {\n    flex-direction: row;\n    padding-left: ",
        "px;\n    text-align: start;\n  }\n"
    ]);
    CardSelectItem_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function CardSelectItem_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: normal;\n  text-align: start;\n"
    ]);
    CardSelectItem_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}







var imageSizeByOrientation = {
    horizontal: 80,
    vertical: 320
};
var CardSelectItem = function(param) {
    var option = param.option, onClick = param.onClick, selected = param.selected, multi = param.multi, orientation = param.orientation;
    var isSelected = react.useMemo(function() {
        if (selected === undefined) return false;
        if (multi) return selected.includes(option.value);
        return selected === option.value;
    }, [
        selected,
        multi,
        option.value
    ]);
    var isMobile = (0,useBreakpoints/* useBreakpointDown */.a)("xs");
    var imageSize = orientation === "horizontal" || isMobile ? imageSizeByOrientation.horizontal : imageSizeByOrientation.vertical;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardSelectItem, {
        onClick: function() {
            return onClick(option.value);
        },
        $selected: isSelected,
        $orientation: orientation,
        children: [
            "image" in option && option.image && /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSelectItemImage, {
                $orientation: orientation,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "",
                    src: option.image,
                    width: imageSize,
                    height: imageSize
                })
            }),
            "imageComponent" in option && option.imageComponent && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(option.imageComponent, {
                    alt: option.label,
                    width: imageSize,
                    height: imageSize
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardSelectItemTypography, {
                $orientation: orientation,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LabelTypography, {
                        variant: "body1",
                        px: 1,
                        children: option.label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        variant: "caption",
                        children: option.subtitle
                    })
                ]
            }),
            orientation === "horizontal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                ml: "auto",
                display: "flex",
                alignItems: "center",
                mr: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg_CheckmarkIcon, {
                    checked: isSelected
                })
            })
        ]
    });
};
var StyledCardSelectItem = styled_components_browser_esm/* default.div */.ZP.div(CardSelectItem_templateObject1(), function(param) {
    var $orientation = param.$orientation;
    return $orientation === "horizontal" ? "start" : "center";
}, function(param) {
    var $orientation = param.$orientation;
    return $orientation === "horizontal" ? "auto 1fr auto" : "1fr";
}, function(props) {
    return props.$selected ? props.theme.palette.secondary.light : props.theme.palette.grey[200];
}, function(props) {
    return props.theme.spacing(0.5);
}, function(props) {
    return props.$selected ? "0 4px 23px 0px rgba(156, 186, 108, 0.2)" : "none";
}, function(props) {
    return props.theme.transitions.create([
        "box-shadow",
        "border-color"
    ], {
        duration: ".2s"
    });
}, function(props) {
    return !props.$selected && (0,styled_components_browser_esm/* css */.iv)(CardSelectItem_templateObject());
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var CardSelectItemImage = styled_components_browser_esm/* default.div */.ZP.div(CardSelectItem_templateObject3(), function(props) {
    return props.$orientation === "horizontal" && (0,styled_components_browser_esm/* css */.iv)(CardSelectItem_templateObject2(), imageSizeByOrientation.horizontal);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, imageSizeByOrientation.horizontal);
var CardSelectItemTypography = styled_components_browser_esm/* default.div */.ZP.div(CardSelectItem_templateObject4(), function(param) {
    var $orientation = param.$orientation, theme = param.theme;
    return $orientation === "horizontal" ? theme.spacing(2) : theme.spacing(0);
}, function(props) {
    return props.$orientation === "horizontal" ? props.theme.spacing(0) : props.theme.spacing(2);
}, function(props) {
    return props.$orientation === "horizontal" ? props.theme.spacing(0) : props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(2);
});
var LabelTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(CardSelectItem_templateObject5());
/* harmony default export */ var CardSelect_CardSelectItem = (CardSelectItem);

;// CONCATENATED MODULE: ./src/system/components/CardSelect/index.tsx

function CardSelect_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          flex-shrink: 0;\n          width: max(",
        ", 33.332%);\n          ",
        " {\n            width: max(",
        ", 50%);\n          } ;\n        "
    ]);
    CardSelect_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CardSelect_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          width: 25%;\n          ",
        " {\n            width: 33.332%;\n          } ;\n        "
    ]);
    CardSelect_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CardSelect_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        "px;\n\n  ",
        "\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    CardSelect_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CardSelect_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-bottom: ",
        "px;\n\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    CardSelect_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var MIN_CARD_WIDTH = "270px";
function CardSelect(param) {
    var questionId = param.questionId, onClick = param.onClick, selected = param.selected, options = param.options, _multi = param.multi, multi = _multi === void 0 ? false : _multi, _orientation = param.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, displayOptions = param.displayOptions, state = param.state;
    var answer = state.qualification.answers[questionId];
    var answerIndex = findIndexOnCollection(answer, options);
    var mustShowAll = answerIndex > displayOptions - 1;
    var ref = (0,react.useState)(mustShowAll ? true : false), showAll = ref[0], setShowAll = ref[1];
    (0,react.useEffect)(function() {
        if (!showAll && mustShowAll) {
            setShowAll(true);
        }
    }, [
        mustShowAll
    ]);
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        setShowAll(mustShowAll ? true : false);
    }, [
        router
    ]);
    var t = (0,es_useTranslation/* useTranslation */.$)("qualification").t;
    var showAllButton = options.length > displayOptions;
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
        textAlign: "center",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCardSelect, {
                className: "card-select",
                id: questionId,
                children: [
                    (showAllButton ? options.slice(0, displayOptions) : options).map(function(option, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSelectItemGridItemLayout, {
                            className: "card-select-item",
                            "data-value": option.value,
                            $orientation: orientation,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSelect_CardSelectItem, {
                                option: option,
                                onClick: onClick,
                                selected: selected,
                                multi: multi,
                                orientation: orientation
                            })
                        }, "".concat(option.value, "::").concat(index));
                    }),
                    showAll && showAllButton && (options === null || options === void 0 ? void 0 : options.slice(displayOptions).map(function(option, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSelectItemGridItemLayout, {
                            className: "card-select-item",
                            "data-value": option.value,
                            $orientation: orientation,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSelect_CardSelectItem, {
                                option: option,
                                onClick: onClick,
                                selected: selected,
                                multi: multi,
                                orientation: orientation
                            })
                        }, "".concat(option.value, "::").concat(index));
                    }))
                ]
            }),
            showAllButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                mb: 5,
                mt: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
                    disabled: mustShowAll,
                    outlined: true,
                    onClick: function() {
                        return setShowAll(!showAll);
                    },
                    variant: "secondary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        py: 0.5,
                        children: showAll ? t("request.form.showLess") : t("request.form.showMore")
                    })
                })
            })
        ]
    });
}
var CardSelectItemGridItemLayout = styled_components_browser_esm/* default.div */.ZP.div(CardSelect_templateObject2(), function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.$orientation === "horizontal" ? (0,styled_components_browser_esm/* css */.iv)(CardSelect_templateObject(), MIN_CARD_WIDTH, function(props) {
        return props.theme.breakpoints.down("sm");
    }, MIN_CARD_WIDTH) : (0,styled_components_browser_esm/* css */.iv)(CardSelect_templateObject1(), function(props) {
        return props.theme.breakpoints.down("sm");
    });
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var StyledCardSelect = styled_components_browser_esm/* default.div */.ZP.div(CardSelect_templateObject3(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
/* harmony default export */ var components_CardSelect = (CardSelect);

;// CONCATENATED MODULE: ./src/qualification/components/question_types/CardSelect.tsx








var CardSelect_CardSelect = function(param) {
    var question = param.question, multi = param.multi, orientation = param.orientation, displayOptions = param.displayOptions;
    var localizedAttributeName = (0,hooks_useLocalizedFieldName/* default */.Z)().localizedAttributeName;
    var ref = (0,context/* useQualification */._8)(), actions = ref.actions, state = ref.state, answerOf = ref.answerOf;
    var localizedOptions = (0,react.useMemo)(function() {
        if (state.status !== "answering") {
            return [];
        }
        var items = question.getItems({
            answers: state.qualification.answers,
            selectedCaterer: state.qualification.selectedCaterer
        });
        return items.map(function(option) {
            return "imageComponent" in option ? {
                value: option.value,
                imageComponent: option.imageComponent,
                // @ts-expect-error TODO: function needs to be typed
                label: option[localizedAttributeName("label")],
                // @ts-expect-error TODO: function needs to be typed
                subtitle: option[localizedAttributeName("subtitle")]
            } : {
                value: option.value,
                image: option.image,
                // @ts-expect-error TODO: function needs to be typed
                label: option[localizedAttributeName("label")],
                // @ts-expect-error TODO: function needs to be typed
                subtitle: option[localizedAttributeName("subtitle")]
            };
        });
    }, [
        question.getItems
    ]);
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    var answer = answerOf(question.id);
    var handleChange = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function(payload) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                actions.answerQuestion(question.id, payload);
                return [
                    2
                ];
            });
        });
        return function handleChange(payload) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CardSelect, {
            questionId: question.id,
            onClick: handleChange,
            selected: answer,
            options: localizedOptions,
            state: state,
            multi: multi,
            orientation: orientation,
            displayOptions: displayOptions
        })
    });
};
/* harmony default export */ var question_types_CardSelect = (CardSelect_CardSelect);

// EXTERNAL MODULE: ./src/qualification/components/question_types/DietaryDistribution.tsx + 1 modules
var DietaryDistribution = __webpack_require__(68106);
// EXTERNAL MODULE: ./src/qualification/components/question_types/DietaryStepper.tsx
var DietaryStepper = __webpack_require__(39979);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/index.js









// EXTERNAL MODULE: ./src/qualification/components/question_types/BudgetQuestionWithPeopleCount/index.tsx + 2 modules
var BudgetQuestionWithPeopleCount = __webpack_require__(8464);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/add/index.js
var add = __webpack_require__(29422);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 18 modules
var format = __webpack_require__(46216);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isFirstDayOfMonth/index.js
var isFirstDayOfMonth = __webpack_require__(44812);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameMonth/index.js
var isSameMonth = __webpack_require__(49160);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/getWeek/index.js + 2 modules
var getWeek = __webpack_require__(13956);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addWeeks/index.js
var addWeeks = __webpack_require__(63500);
// EXTERNAL MODULE: ./node_modules/react-day-picker/dist/index.esm.js + 28 modules
var index_esm = __webpack_require__(4617);
// EXTERNAL MODULE: ./node_modules/react-day-picker/dist/style.css
var style = __webpack_require__(19034);
// EXTERNAL MODULE: ./src/qualification/components/question_types/DatePicker/DatePickerLayout.tsx
var DatePickerLayout = __webpack_require__(53466);
// EXTERNAL MODULE: ./src/qualification/components/question_types/DatePicker/DatePickerSide.tsx + 1 modules
var DatePickerSide = __webpack_require__(23922);
// EXTERNAL MODULE: ./src/qualification/schema/questions/eventDateQuestion.ts
var eventDateQuestion = __webpack_require__(85785);
// EXTERNAL MODULE: ./src/shared/helpers/dates.js
var dates = __webpack_require__(47004);
;// CONCATENATED MODULE: ./src/qualification/components/question_types/DatePicker/DatePickerQF.tsx



function DatePickerQF_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n"
    ]);
    DatePickerQF_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DatePickerQF_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #686d6b;\n  font-size: 12px;\n  line-height: 17px;\n  letter-spacing: 0.4px;\n"
    ]);
    DatePickerQF_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DatePickerQF_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  width: 400px;\n  width: fit-content;\n\n  .rdp {\n    --rdp-accent-color: ",
        ";\n    --rdp-background-color: #a3cb1861;\n    --rdp-cell-size: 42px;\n\n    background-color: white;\n    border-radius: 8px;\n    padding: ",
        ";\n    margin-bottom: 4px;\n  }\n\n  .rdp-head_cell {\n    font-size: 14px;\n    font-weight: 400;\n    padding-bottom: ",
        "px;\n    padding-top: ",
        "px;\n  }\n\n  .rdp-button {\n    transition: background-color 0.2s ease;\n  }\n  .rdp-day_outside {\n    opacity: 0.8;\n  }\n"
    ]);
    DatePickerQF_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}














function DatePickerQF(param) {
    var hasSidebar = param.hasSidebar;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,context/* useQualification */._8)(), actions = ref3.actions, state = ref3.state, answerOf = ref3.answerOf;
    var answer = answerOf(eventDateQuestion/* dateQuestion.id */.uO.id);
    var date = answer ? new Date(answer) : undefined;
    var attributes = "qualification" in state ? eventDateQuestion/* dateQuestion.getAttributes */.uO.getAttributes({
        answers: state.qualification.answers,
        selectedCaterer: state.qualification.selectedCaterer
    }) : null;
    var leadTimeDays = (attributes === null || attributes === void 0 ? void 0 : (ref = attributes.minDate) === null || ref === void 0 ? void 0 : ref.leadTimeDays) || 0;
    var minimumDate = (0,add/* default */.Z)(new Date(), {
        days: leadTimeDays
    });
    var ref4 = (0,react.useState)(date || minimumDate), month = ref4[0], setMonth = ref4[1];
    (0,react.useEffect)(function() {
        if (answerOf("lead_type") === undefined) actions.answerQuestion("lead_type", "private");
    }, [
        answerOf
    ]);
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    var handleDateSelection = function(date) {
        actions.answerQuestion(eventDateQuestion/* dateQuestion.id */.uO.id, date);
    };
    var minDateMessage = router.locale === "en" ? attributes === null || attributes === void 0 ? void 0 : (ref1 = attributes.minDate) === null || ref1 === void 0 ? void 0 : ref1.messageEn : attributes === null || attributes === void 0 ? void 0 : (ref2 = attributes.minDate) === null || ref2 === void 0 ? void 0 : ref2.messageDe;
    var isDateSelectable = function(date) {
        try {
            eventDateQuestion/* dateQuestion.getValidator */.uO.getValidator({
                answers: state.qualification.answers,
                selectedCaterer: state.qualification.selectedCaterer
            }).validateSync(date); // throws if invalid
            return true;
        } catch (e) {
            return false;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerLayout/* default */.Z, {
        mt: 2,
        mb: 3,
        hasSidebar: hasSidebar,
        dateSelector: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DateSelectWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* DayPicker */._W, {
                    components: {
                        Caption: CustomCaption,
                        Row: OnlyAfterToday,
                        Day: DayWithOutsideMonthLabel
                    },
                    formatters: {
                        formatWeekdayName: function(day, options) {
                            return (0,format/* default */.Z)(day, "EEEEE", {
                                locale: options === null || options === void 0 ? void 0 : options.locale
                            });
                        }
                    },
                    mode: "single",
                    month: month,
                    selected: date,
                    onMonthChange: setMonth,
                    fromDate: minimumDate,
                    disabled: function(date) {
                        return !isDateSelectable(date);
                    },
                    onSelect: function(date) {
                        return handleDateSelection(date);
                    },
                    captionLayout: "buttons",
                    locale: router.locale ? dates/* localeToDateLocaleMapping */.Eb[router.locale] : undefined,
                    showOutsideDays: true
                }),
                minDateMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    textAlign: "center",
                    mt: 2,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TypographyCaption, {
                        children: [
                            "*",
                            minDateMessage
                        ]
                    })
                })
            ]
        }),
        sideContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePickerSide/* default */.Z, {})
    });
}
function DayWithOutsideMonthLabel(props) {
    var outside = (0,index_esm/* useActiveModifiers */.JM)(props.date, props.displayMonth).outside;
    var daypicker = (0,index_esm/* useDayPicker */.kD)();
    var isMonthFirstDay = (0,isFirstDayOfMonth/* default */.Z)(props.date);
    if (outside && isMonthFirstDay) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
            position: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    position: "absolute",
                    top: "-3px",
                    left: "-3px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        fontSize: 10,
                        children: (0,format/* default */.Z)(props.date, "MMM", {
                            locale: daypicker.locale
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Day */.Jc, (0,_object_spread/* default */.Z)({}, props))
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Day */.Jc, (0,_object_spread/* default */.Z)({}, props));
}
function CustomCaption(props) {
    var ref = (0,index_esm/* useNavigation */.HJ)(), goToMonth = ref.goToMonth, nextMonth = ref.nextMonth, previousMonth = ref.previousMonth;
    var daypicker = (0,index_esm/* useDayPicker */.kD)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
        display: "flex",
        justifyContent: "space-between",
        py: 1,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthNavigationButton, {
                disabled: !previousMonth,
                onClick: function() {
                    return previousMonth && goToMonth(previousMonth);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconLeft */.hf, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                children: (0,format/* default */.Z)(props.displayMonth, "MMMM", {
                    locale: daypicker.locale
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MonthNavigationButton, {
                disabled: !nextMonth,
                onClick: function() {
                    return nextMonth && goToMonth(nextMonth);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IconRight */.Jp, {})
            })
        ]
    });
}
function OnlyAfterToday(props) {
    var today = new Date();
    var isFirstMonth = (0,isSameMonth/* default */.Z)(today, props.displayMonth);
    if (isFirstMonth) {
        /**
     * Offset the first month, so the fromDate is shown in the first row
     */ var firstWeekOfMonth = (0,getWeek/* default */.Z)(props.displayMonth);
        var weekOfFirstSelectableDay = (0,getWeek/* default */.Z)(today);
        var weekOffset = weekOfFirstSelectableDay - firstWeekOfMonth;
        var datesWithWeekOffset = props.dates.map(function(date) {
            return (0,addWeeks/* default */.Z)(date, weekOffset);
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Row */.X2, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            weekNumber: props.weekNumber + weekOffset,
            dates: datesWithWeekOffset
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Row */.X2, (0,_object_spread/* default */.Z)({}, props));
}
var MonthNavigationButton = styled_components_browser_esm/* default.button */.ZP.button(DatePickerQF_templateObject());
var TypographyCaption = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(DatePickerQF_templateObject1());
var DateSelectWrapper = styled_components_browser_esm/* default.div */.ZP.div(DatePickerQF_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.palette.secondary.light;
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2, 2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
/* harmony default export */ var DatePicker_DatePickerQF = (DatePickerQF);

// EXTERNAL MODULE: ./src/qualification/schema/questions/cateringCategoriesQuestion.ts
var cateringCategoriesQuestion = __webpack_require__(61535);
// EXTERNAL MODULE: ./src/qualification/schema/questions/cityQuestion.tsx
var cityQuestion = __webpack_require__(26407);
// EXTERNAL MODULE: ./src/qualification/schema/questions/customerTierQuestion.ts
var customerTierQuestion = __webpack_require__(30812);
// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/experiments/customer_tier/CustomerTier.js + 1 modules
var CustomerTier = __webpack_require__(35269);
// EXTERNAL MODULE: ./src/shared/components/EmbeddedFunnel/experiments/rare_tier/CustomerRareTier.js + 2 modules
var CustomerRareTier = __webpack_require__(61692);
;// CONCATENATED MODULE: ./src/qualification/components/QuestionFactory.tsx











var QuestionFactory = function(param) {
    var step = param.step, hasSidebar = param.hasSidebar;
    switch(step.id){
        case "city":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(question_types_CardSelect, {
                question: cityQuestion/* cityQuestion */.Vv,
                orientation: "horizontal",
                displayOptions: 10
            });
        case "catering_categories":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(question_types_CardSelect, {
                question: cateringCategoriesQuestion/* cateringCategoriesQuestion */.BN,
                multi: true,
                orientation: "horizontal",
                displayOptions: 6
            });
        case "event_date":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DatePicker_DatePickerQF, {
                hasSidebar: hasSidebar
            });
        case "people_count_and_budget":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                py: 5,
                mt: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BudgetQuestionWithPeopleCount/* default */.Z, {})
            });
        case "dietary_restrictions":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(DietaryDistribution/* default */.Z, {});
        case customerTierQuestion/* customerTierQuestion.id */.MX.id:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                my: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerTier/* default */.Z, {})
            });
        case customerTierQuestion/* rareCustomerTierQuestion.id */.$q.id:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                my: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerRareTier/* default */.Z, {})
            });
        default:
            return null;
    }
};
/* harmony default export */ var components_QuestionFactory = (QuestionFactory);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
;// CONCATENATED MODULE: ./src/qualification/components/QuestionHeader.js

function QuestionHeader_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  margin-bottom: ",
        "px;\n"
    ]);
    QuestionHeader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function QuestionHeader(param) {
    var questionContent = param.questionContent, child = param.child;
    var localizedAttributeName = (0,hooks_useLocalizedFieldName/* default */.Z)().localizedAttributeName;
    var state = (0,context/* useQualification */._8)().state;
    var t = (0,es_useTranslation/* useTranslation */.$)("qualification").t;
    var mobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("xs");
    });
    var title = questionContent[localizedAttributeName("title")];
    var mobileSubtitle = questionContent[localizedAttributeName("mobileSubtitle")];
    var subtitle = questionContent[localizedAttributeName("subtitle")];
    if (state.status === "answering" && state.qualification.step.id.includes("tier-")) {
        title = t("customerTier.title");
        mobileSubtitle = t("customerTier.title");
        subtitle = t("customerTier.subtitle");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                variant: child ? "h6" : "h4",
                px: 3,
                children: title
            }),
            mobile && mobileSubtitle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                width: mobile ? "95%" : "73%",
                display: "inline-block",
                pt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    variant: "caption",
                    children: mobileSubtitle
                })
            }) : subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                width: mobile ? "95%" : "73%",
                display: "inline-block",
                pt: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    variant: "caption",
                    children: subtitle
                })
            })
        ]
    });
}
var Header = styled_components_browser_esm/* default.header */.ZP.header(QuestionHeader_templateObject(), function(props) {
    return props.theme.spacing(2);
});
/* harmony default export */ var components_QuestionHeader = (QuestionHeader);

;// CONCATENATED MODULE: ./src/qualification/components/Question.tsx






function Question(param) {
    var step = param.step, _child = param.child, child = _child === void 0 ? false : _child;
    var state = (0,context/* useQualification */._8)().state;
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            "content" in step && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionHeader, {
                questionContent: step.content,
                child: child
            }),
            step && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionFactory, {
                step: step,
                hasSidebar: !!state.qualification.selectedCaterer
            })
        ]
    });
}
/* harmony default export */ var components_Question = (Question);

// EXTERNAL MODULE: ./src/qualification/components/PillLabel/Pill.tsx
var Pill = __webpack_require__(577);
// EXTERNAL MODULE: ./src/shared/components/StickyBottomSection.js
var StickyBottomSection = __webpack_require__(45437);
;// CONCATENATED MODULE: ./src/qualification/components/Survey/SurveyControlsLayout.tsx




function SurveyControlsLayout_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 1px;\n  background-color: ",
        ";\n  width: 100%;\n  position: absolute;\n"
    ]);
    SurveyControlsLayout_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SurveyControlsLayout_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  box-shadow: 0 0 20px 0 rgb(0 0 0 / 12%);\n"
    ]);
    SurveyControlsLayout_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






/**
 * Lays out the error messages, navigation buttons, and the answer pills
 */ var SurveyControlsLayout = function(param) {
    var answers = param.answers, errors = param.errors, nextButton = param.nextButton, prevButton = param.prevButton, footNote = param.footNote;
    var isMobile = (0,useBreakpoints/* useBreakpointDown */.a)("xs");
    var isDesktop = !isMobile;
    var ref = (0,StickyBottomSection/* useStickyBottomSection */.g)(), trackIfInViewportRef = ref.ref, isFloating = ref.isFloating, floatingSectionHeight = ref.height;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
            display: "flex",
            position: "sticky",
            bottom: "0",
            flexDirection: "column",
            flexGrow: 1,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhiteShadow, {
                mt: "auto",
                children: [
                    answers,
                    errors && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        pb: 2,
                        pt: 1,
                        children: errors
                    }),
                    (answers || errors) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyControlsLayout_Divider, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        px: 1.5,
                        py: 1.5,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                                display: "flex",
                                as: "nav",
                                children: [
                                    prevButton,
                                    nextButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        ml: "auto",
                                        children: nextButton
                                    })
                                ]
                            }),
                            footNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                display: "flex",
                                justifyContent: "center",
                                pt: 0.5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                    variant: "caption",
                                    children: footNote
                                })
                            })
                        ]
                    })
                ]
            })
        });
    }
    if (isDesktop) {
        var ButtonsAndErrors = /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                errors && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                    pt: 2,
                    children: errors
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                    py: 2,
                    px: 4,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                            display: "flex",
                            as: "nav",
                            justifyContent: "center",
                            children: [
                                prevButton,
                                nextButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                    ml: 4,
                                    children: nextButton
                                })
                            ]
                        }),
                        footNote && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            display: "flex",
                            justifyContent: "center",
                            pt: 0.5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "caption",
                                children: footNote
                            })
                        })
                    ]
                })
            ]
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
            ref: trackIfInViewportRef,
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            children: [
                ButtonsAndErrors,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyControlsLayout_StickyBottomSection, {
                    height: floatingSectionHeight,
                    isFloating: isFloating,
                    children: isFloating ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(WhiteShadow, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyControlsLayout_Divider, {}),
                            answers
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteShadow, {
                            mt: "auto",
                            children: answers
                        })
                    })
                })
            ]
        });
    }
    return null;
};
var SurveyControlsLayout_StickyBottomSection = function(_param) {
    var children = _param.children, height = _param.height, isFloating = _param.isFloating, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "height",
        "isFloating"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                display: "flex",
                flexDirection: "column",
                flexGrow: "1",
                bottom: "0",
                left: "0",
                right: "0",
                position: isFloating ? "fixed" : "relative",
                mt: "auto"
            }, restProps), {
                children: children
            })),
            isFloating && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "".concat(height, "px")
                }
            })
        ]
    });
};
var SurveyControlsLayout_Divider = styled_components_browser_esm/* default.div */.ZP.div(SurveyControlsLayout_templateObject(), function(props) {
    return props.theme.palette.grey[250];
});
var WhiteShadow = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(SurveyControlsLayout_templateObject1(), function(props) {
    return props.theme.palette.common.white;
});

// EXTERNAL MODULE: ./src/qualification/components/PillLabel/index.tsx
var PillLabel = __webpack_require__(82179);
// EXTERNAL MODULE: ./src/qualification/hooks/useAnswerPills.ts + 1 modules
var useAnswerPills = __webpack_require__(45078);
;// CONCATENATED MODULE: ./src/qualification/components/Survey/SurveySelection.tsx

function SurveySelection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: ",
        "rem;\n"
    ]);
    SurveySelection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SurveySelection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 600;\n  flex-shrink: 0;\n"
    ]);
    SurveySelection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SurveySelection_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  width: 100%;\n  padding-left: ",
        "px;\n\n  ",
        " {\n    ::-webkit-scrollbar {\n      display: none;\n    }\n  }\n"
    ]);
    SurveySelection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








function SurveySelection(props) {
    var t = (0,es_useTranslation/* useTranslation */.$)("qualification").t;
    var isMobile = (0,useBreakpoints/* useBreakpointDown */.a)("xs");
    var scrollableBoxRef = (0,react.useRef)(null);
    var pillValues = (0,useAnswerPills/* useAnswerPills */.q)({
        display: props.mode
    });
    var currentQuestion = props.mode === "previous-answers" ? props.currentStep : null;
    (0,react.useEffect)(function() {
        var scrollLatestElementIntoView = function scrollLatestElementIntoView() {
            if (!scrollableBoxRef.current) {
                return;
            }
            var horizontalScrollAmount = scrollableBoxRef.current.scrollWidth;
            if (!horizontalScrollAmount) {
                return;
            }
            scrollableBoxRef.current.scroll({
                left: horizontalScrollAmount,
                behavior: "smooth"
            });
        };
        scrollLatestElementIntoView();
    }, [
        currentQuestion,
        scrollableBoxRef
    ]);
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorrizontallyScrollableBox, {
            ref: scrollableBoxRef,
            pt: 2,
            pb: 1.5,
            display: "flex",
            flexWrap: props.wrap ? "wrap" : "nowrap",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    variant: "caption",
                    fontSize: 10,
                    children: t("selection.yourSelection")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PillsWrapperBox, {
                    mx: 2,
                    display: "flex",
                    gap: 1,
                    children: [
                        props.additionalPills ? props.additionalPills : null,
                        pillValues.map(function(pill) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(PillLabel/* default */.Z, {
                                stepId: pill.stepId,
                                text: pill.text || ""
                            }, "".concat(pill.stepId));
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorrizontallyScrollableBox, {
        display: "flex",
        alignItems: "center",
        flexWrap: props.wrap ? "wrap" : "nowrap",
        py: 3.5,
        ref: scrollableBoxRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TypographyYourSelection, {
                variant: "caption",
                fontSize: 14,
                mr: 1.5,
                children: t("selection.yourSelection")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PillsWrapperBox, {
                display: "flex",
                gap: 0.75,
                children: [
                    props.additionalPills ? props.additionalPills : null,
                    pillValues.map(function(pill) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PillLabel/* default */.Z, {
                            stepId: pill.stepId,
                            text: pill.text || ""
                        }, "".concat(pill.stepId));
                    })
                ]
            })
        ]
    });
}
var PillsWrapperBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(SurveySelection_templateObject(), function(props) {
    return props.gap || 1;
});
var TypographyYourSelection = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(SurveySelection_templateObject1());
/* harmony default export */ var Survey_SurveySelection = (SurveySelection);
var HorrizontallyScrollableBox = (0,styled_components_browser_esm/* default */.ZP)(esm/* Box */.xu)(SurveySelection_templateObject2(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
});

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowBackIos.js
var ArrowBackIos = __webpack_require__(71843);
;// CONCATENATED MODULE: ./src/shared/components/ArrowBack.js



function ArrowBack() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBackIos/* default */.Z, {
        viewBox: "0 -5.6 15 35"
    });
}
/* harmony default export */ var components_ArrowBack = (ArrowBack);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowForwardIos.js
var ArrowForwardIos = __webpack_require__(1197);
;// CONCATENATED MODULE: ./src/shared/components/ArrowForward.js



function ArrowForward() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIos/* default */.Z, {
        viewBox: "0 -5.6 15 35"
    });
}
/* harmony default export */ var components_ArrowForward = (ArrowForward);

;// CONCATENATED MODULE: ./src/shared/hooks/useKeyPress.js

function useKeyPress(key) {
    var downHandler = function downHandler(event) {
        if (event.key === key) {
            setKeyPressed(true);
        }
    };
    var ref = (0,react.useState)(false), keyPressed = ref[0], setKeyPressed = ref[1];
    var upHandler = function(event) {
        if (event.key === key) {
            setKeyPressed(false);
        }
    };
    (0,react.useEffect)(function() {
        window.addEventListener("keydown", downHandler);
        window.addEventListener("keyup", upHandler);
        return function() {
            window.removeEventListener("keydown", downHandler);
            window.removeEventListener("keyup", upHandler);
        };
    }, []);
    return {
        keyPressed: keyPressed
    };
}

;// CONCATENATED MODULE: ./src/qualification/components/Survey/SurveyControls.tsx

















function SurveyControls(param) {
    var step = param.step, caterer = param.caterer;
    var ref, ref1;
    var t = (0,es_useTranslation/* useTranslation */.$)("qualification").t;
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("xs");
    var ref2 = (0,context/* useQualification */._8)(), state = ref2.state, actions = ref2.actions, errorsOfStep = ref2.errorsOfStep, canContinue = ref2.canContinue;
    var ref3 = useKeyPress("Enter"), enterPressed = ref3.keyPressed;
    var lastQuestionNextButtonContent = (0,react.useMemo)(function() {
        if (caterer) {
            return t("common:labels.next");
        }
        if (mobile) {
            return t("lastQuestionCTAShort");
        }
        return t("lastQuestionCTA");
    }, [
        caterer,
        mobile
    ]);
    (0,react.useEffect)(function() {
        if (enterPressed) {
            handleNext();
        }
    }, [
        enterPressed
    ]);
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    var qualification = state.qualification;
    var position = qualification.steps.findIndex(function(q) {
        return q.id === qualification.step.id;
    });
    var nextQuestion = qualification.steps[position + 1];
    var prevQuestion = qualification.steps[position - 1];
    var displayBackButton = !!prevQuestion && !prevQuestion.disabled;
    var handleNext = function() {
        var _ref = (0,src_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                actions.nextStep();
                return [
                    2
                ];
            });
        });
        return function handleNext() {
            return _ref.apply(this, arguments);
        };
    }();
    var goBack = function() {
        actions.prevStep();
    };
    var hideNextBtn = function() {
        if (state.status !== "answering") return false;
        var customerTierABCExperiment = (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationB */.Op.customerTierABC.variations.variationB) || (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC);
        if (customerTierABCExperiment && state.qualification.step.id === "rare_customer_tier") return true;
        return false;
    }();
    var NextBtn = function() {
        if (hideNextBtn) return null;
        if (nextQuestion) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Button */.zx, {
                onClick: handleNext,
                size: "lg",
                id: "survey-next",
                "data-current-id": step.id,
                disabled: !canContinue,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        component: "span",
                        lineHeight: 1,
                        variant: "h6",
                        mr: 0.5,
                        children: t("common:labels.next")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArrowForward, {})
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Button */.zx, {
            size: "lg",
            onClick: handleNext,
            disabled: !canContinue,
            id: "searchCaterers",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                    component: "span",
                    lineHeight: 1,
                    variant: "h6",
                    children: lastQuestionNextButtonContent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArrowForward, {})
            ]
        });
    }();
    var errors = errorsOfStep(step.id);
    if (step.id.includes("tier-")) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyControlsLayout, {
        nextButton: NextBtn,
        prevButton: displayBackButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Button */.zx, {
            size: "lg",
            variant: "tertiary",
            onClick: goBack,
            id: "survey-back",
            children: mobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArrowBack, {}) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ArrowBack, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                        variant: "h6",
                        component: "span",
                        lineHeight: 1,
                        ml: 1,
                        children: t("common:labels.back")
                    })
                ]
            })
        }),
        answers: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
            mr: 2,
            pl: [
                0,
                2,
                2,
                4
            ],
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey_SurveySelection, {
                mode: "previous-answers",
                currentStep: step,
                wrap: false,
                additionalPills: caterer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill/* Pill */.D, {
                    children: caterer.company_name
                }) : undefined
            })
        }),
        errors: !!(errors === null || errors === void 0 ? void 0 : errors.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuestionErrors, {
            errors: errors
        }),
        footNote: ((ref = step.content) === null || ref === void 0 ? void 0 : ref.footNote) && t((ref1 = step.content) === null || ref1 === void 0 ? void 0 : ref1.footNote)
    });
}
/* harmony default export */ var Survey_SurveyControls = (SurveyControls);

// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/qualification/components/Survey/index.tsx












function Survey(param) {
    var step = param.step, caterer = param.caterer;
    var ref = (0,next_router.useRouter)(), reorder_offer_id = ref.query.reorder_offer_id;
    var ref1 = (0,context/* useQualification */._8)(), actions = ref1.actions, state = ref1.state;
    var reorderOfferId = state.reorderOfferId;
    if (reorder_offer_id && !reorderOfferId) {
        actions.setReorderOfferId(reorder_offer_id);
    }
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    var selectedCaterer = state.qualification.selectedCaterer;
    var containerSize = "sm";
    var stepId = state.qualification.step.id;
    if (selectedCaterer && stepId === "event_date") {
        containerSize = 1100;
    }
    if (stepId.includes("tier")) {
        containerSize = 1200;
    }
    var containerMargins = {
        xs: 4,
        sm: stepId == schema_steps/* steps.rareCustomerTierStep.id */.S6.rareCustomerTierStep.id && (0,ablyft/* isVariationActive */.s_)(ablyft/* EXPERIMENT.customerTierABC.variations.variationC */.Op.customerTierABC.variations.variationC) ? 0 : 8
    };
    var showSelectedCaterer = selectedCaterer && !stepId.includes("tier");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                mt: containerMargins,
                id: "survey-main",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    size: containerSize,
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        sm: "row"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            mb: {
                                xs: 3,
                                sm: 0
                            },
                            mr: {
                                xs: 0,
                                sm: 2,
                                md: 5
                            },
                            pb: {
                                xs: 0,
                                sm: 4
                            },
                            children: selectedCaterer && showSelectedCaterer && /*#__PURE__*/ (0,jsx_runtime.jsx)(CatererCard, {
                                caterer: selectedCaterer
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            flexGrow: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Question, {
                                step: step
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Survey_SurveyControls, {
                step: step,
                caterer: caterer
            })
        ]
    });
}
/* harmony default export */ var components_Survey = (Survey);

// EXTERNAL MODULE: ./src/qualification/components/Survey/SurveyNavbar.tsx
var SurveyNavbar = __webpack_require__(42149);
;// CONCATENATED MODULE: ./src/qualification/schema/index.ts


var stepsArray = Object.values(schema_steps/* SCHEMA_STEPS */.C$);
function isMainQuestionId(id) {
    var topLevelQuestionIds = stepsArray.map(function(q) {
        return q.id;
    });
    return topLevelQuestionIds.includes(id);
}
var getQuestionById = function(id) {
    return SCHEMA_QUESTIONS[id];
};
var getStepById = function(id) {
    return SCHEMA_STEPS[id];
};

// EXTERNAL MODULE: ./src/shared/helpers/urls.ts
var urls = __webpack_require__(6880);
// EXTERNAL MODULE: ./src/shared/layouts/MainLayout.tsx + 1 modules
var MainLayout = __webpack_require__(89452);
;// CONCATENATED MODULE: ./src/pages/start/[stepId].tsx











var ENTRY_POINT = "/start";
function Step(param) {
    var ratings = param.ratings;
    var router = (0,next_router.useRouter)();
    var ref = (0,context/* useQualification */._8)({
        onQuestionChange: (0,react.useCallback)(function(step) {
            // Change the route, when the question changes
            var updateRouteOnQuestionChange = function() {
                if (!step) {
                    router.push({
                        pathname: ENTRY_POINT,
                        query: (0,urls/* getQueryParams */.vl)()
                    });
                }
                if (step) {
                    if (!router.pathname.includes(step.id)) {
                        router.push({
                            pathname: step.id,
                            query: (0,urls/* getQueryParams */.vl)()
                        }, undefined, {
                            shallow: true
                        });
                    }
                }
            };
            updateRouteOnQuestionChange();
        }, [
            router === null || router === void 0 ? void 0 : router.replace
        ]),
        onAllQuestionAnswered: (0,react.useCallback)(function() {
            router.replace("finding-caterers");
        }, [
            router
        ])
    }), state = ref.state, actions = ref.actions;
    // Route hooks, to syc with state, and validate the routes
    (0,react.useEffect)(function() {
        var updateQuestionOnRouteChange = function(url) {
            var pathnameParts = url.split("/");
            var questionId = pathnameParts[pathnameParts.length - 1];
            if (isMainQuestionId(questionId)) {
                actions.setQuestion(questionId);
            }
        };
        router.events.on("routeChangeStart", updateQuestionOnRouteChange);
        return function() {
            router.events.off("routeChangeStart", updateQuestionOnRouteChange);
        };
    }, [
        router,
        state
    ]);
    (0,react.useEffect)(function() {
        if (state.status === model/* QUALIFICATION_STATUS.qualifiedForRequest */.w.qualifiedForRequest) {
            actions.prevStep(); // Move back into 'answering' status
            return;
        }
        if (state.status === model/* QUALIFICATION_STATUS.initial */.w.initial) {
            router.replace(ENTRY_POINT);
        }
        router.prefetch("/start/finding-caterers");
    }, [
        state.status,
        router
    ]);
    if (state.status !== model/* QUALIFICATION_STATUS.answering */.w.answering) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* PageLayout */.X, {
        main: state.qualification.step && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SurveyNavbar/* default */.Z, {
                    ratings: ratings
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Survey, {
                    step: schema_steps/* SCHEMA_STEPS */.C$[state.qualification.step.id],
                    caterer: state.qualification.selectedCaterer
                })
            ]
        })
    });
}
var __N_SSG = true;
/* harmony default export */ var _stepId_ = ((0,context/* withQualificationProvider */.qj)({
    storageKey: "__funnel",
    storage: "sessionStorage"
}, Step));


/***/ }),

/***/ 45437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useStickyBottomSection; },
/* harmony export */   "k": function() { return /* binding */ StickyBottomSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95197);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70131);







var StickyBottomSection = function(_param) {
    var children = _param.children, height = _param.height, isFloating = _param.isFloating, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "height",
        "isFloating"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                display: "flex",
                flexDirection: "column",
                flexGrow: "1",
                bottom: "0",
                left: "0",
                right: "0",
                position: isFloating ? "fixed" : "relative"
            }, restProps), {
                children: children
            })),
            isFloating && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    height: "".concat(height, "px")
                }
            })
        ]
    });
};
function useStickyBottomSection() {
    var ref, ref1;
    var ref2 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_6__/* .useInView */ .YD)({
        threshold: 1
    }), inView = ref2.inView, ref3 = ref2.ref, intersectionEntry = ref2.entry;
    var floatingSectionHeight = (intersectionEntry === null || intersectionEntry === void 0 ? void 0 : (ref = intersectionEntry.boundingClientRect) === null || ref === void 0 ? void 0 : ref.height) || 0;
    var isUnderViewport = intersectionEntry ? ((ref1 = intersectionEntry.boundingClientRect) === null || ref1 === void 0 ? void 0 : ref1.y) > 0 : true;
    var isFloating = !inView && isUnderViewport;
    return {
        height: floatingSectionHeight,
        isFloating: isFloating,
        ref: ref3
    };
}


/***/ }),

/***/ 66442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ QualityAndSafetyIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62087);






function QualityAndSafetyIcon(_param) {
    var size = _param.size, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "size"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 595.28 595.28",
        height: size,
        width: size
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#f28c0b",
                d: "M396.58 394.93a57 57 0 01-29.35 7h-7.8l-52.14 121.26L337 592.4a4.74 4.74 0 008.72 0l37.08-95.77 94.93 39.1a4.74 4.74 0 006.14-6.2L417 373.54a56.75 56.75 0 01-20.42 21.39zM283.8 425.12c-17.91 0-31.3-9.48-41.82-17.08a62.65 62.65 0 00-11.78-7 17.36 17.36 0 00-4.25-.35 58.71 58.71 0 00-10.46.63c-4.74.42-9.62.83-14.84.83a56.92 56.92 0 01-29.35-7 48.32 48.32 0 01-8.08-5.92L103 529.39a4.74 4.74 0 002.59 6.18 4.69 4.69 0 003.55 0l94.93-39.1 37.08 95.77a4.74 4.74 0 008.72 0l80-186.94-3.87 3.09c-10.9 6.97-24.29 16.73-42.2 16.73zM283.93 61.25A139.57 139.57 0 10423.5 200.82 139.57 139.57 0 00283.93 61.25z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#f28c0b",
                d: "M460.14 248.11c4.25-15.75 23.42-30.11 23.42-47.26s-19.24-31.43-23.42-47.26 4.95-38.33-3.27-52.62S424.66 83.61 413 71.83s-14.63-35.55-29.13-44-36.32 1-52.63-3.28S301.08 1.15 284 1.15s-31.43 19.17-47.25 23.42-38.34-4.95-52.63 3.28-17.36 32.2-29.14 44-35.54 14.62-43.91 29.15 1.05 36.31-3.34 52.62-23.42 30.08-23.42 47.23 19.16 31.44 23.42 47.19-5 38.34 3.34 52.63S143.21 318 155 329.8s14.64 35.55 29.14 43.91 36.32-1 52.63 3.35 30.11 23.42 47.25 23.42 31.44-19.24 47.19-23.42 38.34 4.95 52.63-3.28 17.35-32.2 29.13-43.91 35.55-14.64 44-29.14-1.15-36.31 3.17-52.62zm-176.21 112.5a159.69 159.69 0 11159.69-159.69 159.85 159.85 0 01-159.69 159.69z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M352.39 161.53c-.19 4.27-.33 8.53-.56 12.78q-.45 8.16-1.65 16.25A113.85 113.85 0 01325.45 248a151.67 151.67 0 01-17.08 17.76 217.94 217.94 0 01-20.61 16.12 6.38 6.38 0 01-7.63 0 209.36 209.36 0 01-23.86-19.06 140.24 140.24 0 01-17.44-19.49 110.8 110.8 0 01-17.3-35 130.06 130.06 0 01-3.66-16.67c-.58-3.76-1-7.54-1.37-11.33-.88-9.58-1-19.19-1.06-28.8a6.56 6.56 0 015.33-6.5 143 143 0 0025.93-7.7 180.28 180.28 0 0028.3-14.25c1.72-1.06 3.39-2.19 5.07-3.3a6.83 6.83 0 013.9-1.25 6.5 6.5 0 013.62 1.15 155 155 0 0013.65 8.32 171.69 171.69 0 0034.16 14.24c3.87 1.12 7.79 2 11.74 2.83a6.42 6.42 0 015.29 6.45v5.07c0 1.69-.04 3.28-.04 4.94zm-68.45-28.78a185 185 0 01-55.59 23.82v.89c.11 4.33.17 8.67.34 13 .13 3.09.33 6.19.61 9.28.38 4.24.89 8.47 1.63 12.67a121.09 121.09 0 002.71 12 96.44 96.44 0 0012 26.39 120.37 120.37 0 0018.24 21.54 188.31 188.31 0 0019.45 16c.2.15.41.28.6.41l.37-.25a194.11 194.11 0 0018.15-14.72 130.18 130.18 0 0015.66-17.11 97.45 97.45 0 0016.87-35 133.69 133.69 0 003.52-21.3c.36-3.89.58-7.8.75-11.7s.17-7.57.25-11.35v-.71a184.15 184.15 0 01-55.56-23.86z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fill: "#fff",
                d: "M280 207.13c.21-.26.37-.5.56-.69l32.21-32.23.76-.73a4.46 4.46 0 015.9-.15c2.06 1.85 4 3.82 5.89 5.87a4.55 4.55 0 010 5.74 10.55 10.55 0 01-.72.78l-40.93 40.94a5 5 0 01-4.28 1.62 4.55 4.55 0 01-2.74-1.32l-3.65-3.54-19.88-19.51a5.15 5.15 0 01-1.6-2.76 4.47 4.47 0 011.16-4.06c1.65-1.74 3.35-3.43 5-5.14a4.86 4.86 0 016.85.06c4.92 4.9 9.9 9.73 14.85 14.58z"
            })
        ]
    }));
}


/***/ }),

/***/ 70131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; },
/* harmony export */   "df": function() { return /* binding */ InView; }
/* harmony export */ });
/* unused harmony exports default, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var observerMap = new Map();
var RootIds = new WeakMap();
var rootId = 0;
var unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(function (key) {
    return options[key] !== undefined;
  }).map(function (key) {
    return key + "_" + (key === 'root' ? getRootId(options.root) : options[key]);
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  var id = optionsToId(options);
  var instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    var elements = new Map();
    var thresholds;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        var inView = entry.isIntersecting && thresholds.some(function (threshold) {
          return entry.intersectionRatio >= threshold;
        }); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(function (callback) {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id: id,
      observer: observer,
      elements: elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options, fallbackInView) {
  if (options === void 0) {
    options = {};
  }

  if (fallbackInView === void 0) {
    fallbackInView = unsupportedValue;
  }

  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    var bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return function () {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  var _createObserver = createObserver(options),
      id = _createObserver.id,
      observer = _createObserver.observer,
      elements = _createObserver.elements; // Register the callback listener for this element


  var callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements["delete"](element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap["delete"](id);
    }
  };
}

var _excluded = ["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"];

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


var InView = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InView, _React$Component);

  function InView(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.node = null;
    _this._unobserveCb = null;

    _this.handleNode = function (node) {
      if (_this.node) {
        // Clear the old observer, before we start observing a new element
        _this.unobserve();

        if (!node && !_this.props.triggerOnce && !_this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          _this.setState({
            inView: !!_this.props.initialInView,
            entry: undefined
          });
        }
      }

      _this.node = node ? node : null;

      _this.observeNode();
    };

    _this.handleChange = function (inView, entry) {
      if (inView && _this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        _this.unobserve();
      }

      if (!isPlainChildren(_this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        _this.setState({
          inView: inView,
          entry: entry
        });
      }

      if (_this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        _this.props.onChange(inView, entry);
      }
    };

    _this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
    return _this;
  }

  var _proto = InView.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unobserve();
    this.node = null;
  };

  _proto.observeNode = function observeNode() {
    if (!this.node || this.props.skip) return;
    var _this$props = this.props,
        threshold = _this$props.threshold,
        root = _this$props.root,
        rootMargin = _this$props.rootMargin,
        trackVisibility = _this$props.trackVisibility,
        delay = _this$props.delay,
        fallbackInView = _this$props.fallbackInView;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold: threshold,
      root: root,
      rootMargin: rootMargin,
      // @ts-ignore
      trackVisibility: trackVisibility,
      // @ts-ignore
      delay: delay
    }, fallbackInView);
  };

  _proto.unobserve = function unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  };

  _proto.render = function render() {
    if (!isPlainChildren(this.props)) {
      var _this$state = this.state,
          inView = _this$state.inView,
          entry = _this$state.entry;
      return this.props.children({
        inView: inView,
        entry: entry,
        ref: this.handleNode
      });
    }

    var _this$props2 = this.props,
        children = _this$props2.children,
        as = _this$props2.as,
        props = _objectWithoutPropertiesLoose(_this$props2, _excluded);

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  };

  return InView;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
InView.displayName = 'InView';
InView.defaultProps = {
  threshold: 0,
  triggerOnce: false,
  initialInView: false
};

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      threshold = _ref.threshold,
      delay = _ref.delay,
      trackVisibility = _ref.trackVisibility,
      rootMargin = _ref.rootMargin,
      root = _ref.root,
      triggerOnce = _ref.triggerOnce,
      skip = _ref.skip,
      initialInView = _ref.initialInView,
      fallbackInView = _ref.fallbackInView;

  var unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();

  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function (node) {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, function (inView, entry) {
        setState({
          inView: inView,
          entry: entry
        });

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold,
        // @ts-ignore
        trackVisibility: trackVisibility,
        // @ts-ignore
        delay: delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  var result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.m.js.map


/***/ }),

/***/ 82670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,7879,9433,5675,2311,7766,8184,4566,4872,3992,9648,4254,3704,5643,6888,7086,9774,2888,179], function() { return __webpack_exec__(69832); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);